/* <media-gallery> — thumbnail selection + variant image sync.
   Listens for `variant:change` on the product section to swap to the
   selected variant's featured media. */
class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".gallery__thumb").forEach((thumb) =>
      thumb.addEventListener("click", () => this.setActive(thumb.dataset.thumbId))
    );
    this.closest("[data-product-section]")?.addEventListener("variant:change", (e) => {
      const id = e.detail?.variant?.featured_media?.id;
      if (id) this.setActive(String(id));
    });
  }

  setActive(mediaId) {
    const id = String(mediaId);
    this.querySelectorAll(".gallery__slide").forEach((slide) => {
      const on = slide.dataset.mediaId === id;
      slide.classList.toggle("is-active", on);
      slide.hidden = !on;
    });
    this.querySelectorAll(".gallery__thumb").forEach((thumb) =>
      thumb.classList.toggle("is-active", thumb.dataset.thumbId === id)
    );
  }
}
if (!customElements.get("media-gallery")) customElements.define("media-gallery", MediaGallery);
